import {NgModule} from '@angular/core';
import {FullscreenDirective} from './fullscreen.directive';

@NgModule({
  declarations: [
    FullscreenDirective
  ],
  providers: [
    FullscreenDirective
  ],
  exports: [
    FullscreenDirective
  ],
})
export class UtilsModule {
}
